import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { DealerBalanceModel, DeleteDealerBalanceRQ, GetDealerBalanceRQ } from "app/open-api";
import { DealerBalanceService } from "app/open-api/api/dealerBalance.service";
import { DealerBalanceDetailComponent } from "app/shared/components/dealer-balance-detail/dealer-balance-detail.component";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";

@Component({
  selector: "app-dealer-balance",
  templateUrl: "./dealer-balance.component.html",
  styleUrls: ["./dealer-balance.component.scss"],
})
export class DealerBalanceComponent implements OnInit {
  public basicSelectedOption: number = 5;
  public ColumnMode = ColumnMode;
  balances: DealerBalanceModel[] = [];
  allBalances: DealerBalanceModel[] = [];

  constructor(
    private dealerBalanceService: DealerBalanceService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.FetchModels();
  }

  FetchModels() {
    this.spinner.show();
    this.dealerBalanceService
      .apiDealerBalanceListGet()
      .subscribe((response) => {
        this.balances = response.list;
        this.allBalances = response.list;
        this.spinner.hide();
      });
  }

  FilterUpdate(event) {
    if (event && event !== "") {
      this.balances = this.allBalances.filter(
        (x) =>
          x.dealerName.toLowerCase().indexOf(event.toLowerCase()) > -1 &&
          x.shippingCode.toLowerCase().indexOf(event.toLowerCase()) > -1
      );
    } else {
      this.balances = this.allBalances;
    }
  }

  DeleteBalance(billId: number): void {
    const swal = Swal.fire({
      title: "¿Está seguro que desea eliminar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        const param: DeleteDealerBalanceRQ = {
          dealerBalanceId: billId,
        };
        this.dealerBalanceService.apiDealerBalanceDeletePost(param).subscribe(
          (resp) => {
            Swal.fire({
              title: "Cierre Eliminado",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.FetchModels();
            this.spinner.hide();
          },
          (err) => {
            Swal.fire({
              title: "Error! " + err,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        );
      }
    });
  }

  SeeDetails(billId: number) {
    this.spinner.show();
    const param: GetDealerBalanceRQ = {
      dealerBalanceId: billId
    };
    this.dealerBalanceService.apiDealerBalanceGetPost(param).subscribe(resp => {
      const refModal = this.modalService.open(DealerBalanceDetailComponent, {
        windowClass: 'modal',
        size: 'xl',
      });
      refModal.componentInstance.data = resp;      
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
    });
  }
}
